import { Injectable } from '@angular/core';
import { AvailableAppNavV2Service } from '../app-nav-v2/available-app-nav-v2.service';
import { ProductAppCodes } from '../product-info/product-info.service';
import { AppNavV2 } from 'src/app/shared/models/app-nav-v2.model';

export enum TeacherLicenseCheckMethods {
  FRECKLE = 'teacherHasFreckle',
  LALILO = 'teacherHasLalilo',
  MYON = 'teacherHasMyon',
}

@Injectable({
  providedIn: 'root'
})
export class TeacherLicenseInfoService {
  private appNavApps: AppNavV2[] = [];
  private appNavAppsLoaded = false;

  constructor(private availableApppNavServiceV2: AvailableAppNavV2Service) {}

  public async teacherHasFreckle(): Promise<boolean> {
    return await this.hasProductLicense([
      ProductAppCodes.Freckle,
      ProductAppCodes.FreckleMath,
      ProductAppCodes.FreckleReading
    ])
  }

  public async teacherHasLalilo(): Promise<boolean> {
    return await this.hasProductLicense([ProductAppCodes.Lalilo])
  }

  public async teacherHasMyon(): Promise<boolean> {
    return await this.hasProductLicense([ProductAppCodes.Myon])
  }

  private async hasProductLicense(appCodes: string[]): Promise<boolean> {
    if (!this.appNavAppsLoaded) {
      await this.availableApppNavServiceV2.isLoaded();
      this.appNavApps = this.availableApppNavServiceV2.getAppNavV2();
      this.appNavAppsLoaded = true;
    }

    return this.appNavApps.some(app => app.appCode && appCodes.includes(app.appCode));
  }
}
